/**
 * ゲーム内で使用されるイベントタイプの定数
 * イベント名の一貫性を保ち、タイプミスを防止するために使用します
 */
export const EventTypes = {
    // 衝突関連イベント
    COLLISION: {
        WEIGHT_TARGET: 'collision:weight-target'
    },
    
    // ターゲット関連イベント
    TARGET: {
        MOVEMENT_START: 'target:movement:start'
    },
    
    // タイマー関連イベント
    TIMER: {
        TIMEUP: 'timer:timeup'
    }
};
